import { Button } from "@shared/components";
import { useGameErrorStatus } from "@shared/hooks/games";
import { useUserError } from "@shared/hooks/user";
import React from "react";
import "./style.scss";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";

export const ErrorFetchingView = () => {
  const intl = useIntl();
  const { message: userErrorMessage } = useUserError();
  const { message: gamesErrorMessage } = useGameErrorStatus();
  const history = useHistory();
  const isGamePage = history?.location?.pathname.includes("/games/");
  const error = isGamePage ? gamesErrorMessage : userErrorMessage;
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="error-view">
      <div className="error-view__content">
        <h1> {intl.formatMessage({ id: "network-error-title" })}</h1>
        <h2>{intl.formatMessage({ id: "network-error-try-text" })}</h2>
        <code className="games-code">{error}</code>
        <Button
          onClick={handleRetry}
          className="error-view__button"
          type="submit"
          variant="primary"
          size="lg"
          tagName="button"
        >
          {intl.formatMessage({ id: "retry" })}
        </Button>
      </div>
    </div>
  );
};
